import { filterClasses } from "@swivl-mono/helpers";

interface PolicyRadioOption {
  label: string;
  value: string;
}

interface PolicyRadioProps {
  value: string;
  options: PolicyRadioOption[];
  disabled?: boolean;
  onChange: (value: string) => void;
}

/** Soft stacked radio for worksheet radio items. */
export function PolicyRadio({ value, options, disabled, onChange }: PolicyRadioProps): React.ReactElement {
  return (
    <div className="flex flex-col gap-2" role="radiogroup">
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => {
              if (!disabled) onChange(option.value);
            }}
            className={filterClasses(
              "flex items-center gap-3 rounded-sm border px-3.5 py-3 text-left text-sm text-grey-900 transition-colors",
              selected ? "border-orange-400 bg-orange-50" : "border-grey-300 hover:border-grey-400",
              disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
            )}
          >
            <span
              className={filterClasses(
                "relative flex size-[18px] shrink-0 items-center justify-center rounded-full border-2",
                selected ? "border-orange-500" : "border-grey-400"
              )}
            >
              {selected && <span className="size-2 rounded-full bg-orange-500" />}
            </span>
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
